__turbopack_context__.v({
  "activePage": "h17NnG_activePage",
  "container": "h17NnG_container",
  "overlay": "h17NnG_overlay",
  "page": "h17NnG_page",
  "paginationWrapper": "h17NnG_paginationWrapper",
  "skeletonStyles": "h17NnG_skeletonStyles",
});
